// NOTA: Este arquivo agora re-exporta as cores de materialSystem.ts
// para manter compatibilidade com código legado
// SEMPRE use MATERIAL_COLORS de @/utils/materialSystem como fonte única
import { MATERIAL_COLORS } from '@/utils/materialSystem';

// Re-exporta as cores de materiais da fonte única de verdade
export const materialColors = {
  ...MATERIAL_COLORS,
  // Manter aliases legados para compatibilidade
  'Óleo usado': MATERIAL_COLORS['Óleo'],
  // Fallbacks para valores em minúsculas (compatibilidade legada)
  'non_recyclable': MATERIAL_COLORS['Não reciclável'],
  'recyclable': MATERIAL_COLORS['Reciclável'],
  'comum': MATERIAL_COLORS['Comum'],
  'orgânico': MATERIAL_COLORS['Orgânico'],
  'eletrônico': MATERIAL_COLORS['Eletrônico'],
  'madeira': MATERIAL_COLORS['Madeira']
};

export const statusColors = {
  success: '#36B37E',   // verde
  delay: '#FFC107',     // amarelo
  failed: '#FF5E48',    // vermelho de destaque

  // Status mapping
  'Sucesso': '#36B37E',
  'Atraso': '#FFC107',
  'Não realizada': '#FF5E48'
};

/**
 * Cores do status de coleta usadas nos cards e gráficos de distribuição.
 * Fonte única — não repetir estes valores em componentes ou hooks.
 */
export const collectStatusColors = {
  destined: '#2D5A3D',              // verde escuro
  collected: '#4A5568',             // cinza azulado
  fault: statusColors.failed,
} as const;

export const chartColors = {
  grid: '#E5E7EB',        // cinza claro para grid
  axis: '#6B7280',        // cinza-escuro para texto dos eixos
  neutral: '#6B7280',     // tom neutro para barras simples
  background: '#FFFFFF'   // fundo branco
};
